<template>
	<div class="mt5- mb5">
		<v-row class="ventaItemContainer" @click="$emit('on_click', venta)">
			<v-col cols="12">
<!--				<div :class="{'sucess&#45;&#45;text': venta.is_pagada === true, 'error&#45;&#45;text': venta.is_pagada === false}" class="font-weight-bold">-->
				<div class="font-weight-bold">
<!--					<v-icon small>mdi-calendar</v-icon> {{ venta.fecha }}-->
					<v-icon small>mdi-calendar-clock</v-icon> 2021-07-01 12:00
				</div>

				<v-simple-table>
					<template v-slot:default>
						<thead>
							<tr>
								<th class="text-capitalize">
									Cantidad
								</th>
								<th class="text-capitalize">
									Concepto
								</th>
								<th class="text-capitalize">
									Empleado
								</th>
								<th class="text-capitalize">
									Descuento
								</th>
								<th class="text-capitalize">
									Total
								</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>
									1
								</td>
								<td>
									Estética
								</td>
								<td>
									Flurfils McFlur
								</td>
								<td>
									0 €
								</td>
								<td>
									420,69 €
								</td>
							</tr>
							<tr>
								<td>
									Descuento
								</td>
								<td />
								<td />
								<td />
								<td>
									0 %
								</td>
							</tr>
							<tr>
								<td>
									Forma de pago
								</td>
								<td />
								<td />
								<td />
								<td>
<!--									{{ venta.forma_pago.text }}-->
									Efectivo
								</td>
							</tr>
							<tr>
								<td>
									<span class="font-weight-bold">Importe total de la venta</span>
								</td>
								<td />
								<td />
								<td />
								<td>
									<span class="font-weight-bold">420,69 €</span>
								</td>
							</tr>
						</tbody>
					</template>
				</v-simple-table>
			</v-col>
		</v-row>
	</div>
</template>

<script>
export default {
	name: "MiniVentaOnline",
	// props: {
	// 	venta: {
	// 		type: Object,
	// 		required: true
	// 	}
	// }
}
</script>

<style scoped>

</style>